import Setup from './Setup';
import MakingNutritiousFoodChoices from './MakingNutritiousFoodChoices';
import ShowWhatYouKnow from './ShowWhatYouKnow';
import Question1 from './Question1';
import Question2 from './Question2';
import Question3 from './Question3';
import ConfidenceRanking from './ConfidenceRanking';

export default {
  title: 'Prepare',
  children: [
    Setup,
    MakingNutritiousFoodChoices,
    ShowWhatYouKnow,
    Question1,
    Question2,
    Question3,
    ConfidenceRanking
  ]
};



// WEBPACK FOOTER //
// ./src/data/prepare/index.js